module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"write_article":"Начните писать {pageType}...","articles":"статью","news":"новость"}}')
  delete Component.options._Ctor
}
